<template>
    <v-layout>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex v-if="!loading">
            <v-card flat>
                <v-card-title class="primary headline white--text">
                    {{ 'Maintenance Record'|translate }}
                    <v-spacer></v-spacer>
                    <date-range-selector v-if="!dateRange" v-model="range" @change="refresh"></date-range-selector>
                </v-card-title>
                <v-layout row wrap>
                    <v-flex xs2>
                        <value-box
                            :value="maintenanceRecords.length"
                            icon=""
                            use-int
                            :title="'Total'|translate">
                        </value-box>

                    </v-flex>
                    <v-flex xs2>
                        <value-box
                            :value="totalFixed"
                            icon=""
                            use-int
                            :title="'Fixed'|translate">
                        </value-box>
                    </v-flex>
                    <v-flex xs2>
                        <value-box
                            :value="totalToMe"
                            icon=""
                            use-int
                            :title="'Assigned to me'|translate">
                        </value-box>
                    </v-flex>
                    <v-flex xs2>
                        <value-box
                            :value="totalByMe"
                            icon=""
                            use-int
                            :title="'Assigned by me'|translate">
                        </value-box>
                    </v-flex>

                    <v-switch color="success" class="ml-4" v-model="showMineOnly" v-on:change="refineDeserts"
                              :label="'Show Mine Only'|translate"></v-switch>
                    <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>


                </v-layout>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="uploadDialogSwitch = true"
                           :disabled="!$can('update', 'MaintenanceRecord')">
                        <v-icon small class="mr-2">fa-file-excel</v-icon>
                        {{ 'Bulk Upload Excel'|translate }}
                    </v-btn>
                    <v-btn class="accent" @click="changeAssignDiag = true"
                           :disabled="!$can('update', 'MaintenanceRecord')">
                        <v-icon small class="mr-2">fa-user-edit</v-icon>
                        {{ 'Mass reassign'|translate }}
                    </v-btn>

                    <v-btn class="accent" @click="editedItem=null;dialog=true"
                           :disabled="!$can('update', 'MaintenanceRecord')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <v-btn class="accent" @click="exportMR">
                        <v-icon small class="mr-2">fa-download</v-icon>
                        {{ 'Download'|translate }}
                    </v-btn>
                    <fault-record-dialog v-model="dialog" :item="editedItem"
                                         v-on:doreload="refresh()"></fault-record-dialog>
                    <v-dialog v-model="changeAssignDiag" max-width="500">
                        <v-card v-if="changeAssignDiag">
                            <v-card-title class="primary white--text title">
                                {{ 'Reassign user for all maintenance records'|translate }}
                            </v-card-title>
                            <v-card-text>
                                <v-select
                                    :items="userNames"
                                    :label="'Currently assigned to'|translate"
                                    v-model="reassignFrom"
                                ></v-select>
                                <v-select
                                    :items="userNames"
                                    :label="'Reassign to'|translate"
                                    v-model="reassignTo"
                                ></v-select>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="primary" @click="runReassign()"
                                       :disabled="!$can('update', 'MaintenanceRecord')||!reassignFrom||!reassignTo">
                                    {{ 'Reassign'|translate }}
                                </v-btn>
                                <v-btn @click="changeAssignDiag=false">{{ 'Cancel'|translate }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-actions>
                <maintenance-upload-dialog v-model="uploadDialogSwitch"
                                           v-if="uploadDialogSwitch"></maintenance-upload-dialog>
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="maintenanceRecords"
                        :search="search2"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        disable-initial-sort
                        :pagination.sync="pagination"
                        :items-per-page="25"
                    >
                        <template v-slot:items="props">
                            <td @click="editItem(props.item)" class="cursor-as-pointer text-xs-left">
                                {{ props.item.maintenance_id }}
                            </td>
                            <td @click="editItem(props.item)" class="cursor-as-pointer text-xs-left">
                                {{ props.item.maintenance_label }}
                            </td>
                            <td @click="editItem(props.item)" class="cursor-as-pointer text-xs-left">
                                {{ props.item.equipment }}
                            </td>
                            <td @click="editItem(props.item)" class="cursor-as-pointer text-xs-left">
                                {{ props.item.maintenance_date_from }}
                            </td>
                            <td @click="editItem(props.item)" class="cursor-as-pointer text-xs-left">
                                {{ props.item.maintenance_date_to }}
                            </td>
                            <td @click="editItem(props.item)" class="cursor-as-pointer text-xs-left">
                                <v-icon v-if="props.item.is_fixed" color="success">fa-check</v-icon>
                                <v-icon v-else color="warning">fa-times</v-icon>
                            </td>
                            <td @click="editItem(props.item)" class="cursor-as-pointer text-xs-left">
                                <severity-chip v-if="props.item.severity" :value="props.item.severity"></severity-chip>
                            </td>
                            <td @click="editItem(props.item)" class="cursor-as-pointer text-xs-left">
                                {{ props.item.assigned_to }}
                            </td>
                            <td @click="editItem(props.item)" class="cursor-as-pointer text-xs-left">
                                {{ props.item.assigned_by }}
                            </td>
                            <td @click="editItem(props.item)" class="cursor-as-pointer text-xs-left">
                                <span v-if="props.item.assigned_date&&props.item.assigned_date!=='NaT'">{{
                                        props.item.assigned_date.substring(0, 10)
                                    }}</span>
                            </td>
                            <td class="justify-center layout px-0">
                                <v-icon
                                    small
                                    v-if="props.item.url"
                                    @click="jumpToLink(props.item.url)"
                                    class="mr-2"
                                >
                                    fa-chart-line
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'MaintenanceRecord')"
                                    class="mr-2"
                                    @click="$can('update', 'MaintenanceRecord') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'MaintenanceRecord')"
                                    @click="$can('update', 'MaintenanceRecord') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Refresh'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import _ from 'lodash'
import ValueBox from '@/components/ValueBox'
import FaultRecordDialog from '../components/FaultRecordDialog'
import {getMaintenanceRecords, deleteMaintenanceRecord, getUser, callAPI} from '../helper'
import MaintenanceUploadDialog from '../components/maintenance/MaintenanceUploadDialog'
import DateRangeSelector from '../components/DateRangeSelector'
import {exportCSV} from '../tocsv'
import moment from 'moment'
import SeverityChip from "../components/SeverityChip";

export default {
    name: 'MaintenanceRecord',
    components: {MaintenanceUploadDialog, FaultRecordDialog, ValueBox, DateRangeSelector, SeverityChip},
    props: {
        dashboardMode: {type: Boolean, default: false},
        equipmentFilter: {type: String, default: null},
        dateRange: {type: Object, default: null},
    },
    beforeMount() {
        // popular with query
        if (this.dateRange) {
            this.range = {...this.dateRange}
        } else {
            let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
            let rangeStart = _.get(this.$route.query, 'rangeStart', null)
            let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
            if (!!rangeStart) {
                this.range = {start: rangeStart, end: rangeEnd}
            } else if (maxDate) {
                this.range = {
                    start: moment(maxDate).subtract(1, "years").format('YYYY-MM-DD HH:mm:ss'),
                    end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
                }
            }
        }

    },
    watch: {
        dateRange() {
            if (this.dateRange) {
                this.range = {...this.dateRange}
            }
        },
        equipmentFilter() {
            this.refineDeserts();
        },
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    computed: {
        totalFixed() {
            return _.filter(this.maintenanceRecords, function (x) {
                return (x.is_fixed)
            }).length
        },
        totalToMe() {
            return (this.maintenanceRecords.filter(x => x.assigned_to == this.username).length)
        },
        totalByMe() {
            return (this.maintenanceRecords.filter(x => x.assigned_by == this.username).length)
        },
        username() {
            if (this.$store.state.userStore.user) {
                return this.$store.state.userStore.user.content.user_name
            }
            return null;
        },
        showexclude() {
            if (this.$store.state.userStore.user) {
                if (process.env.VUE_APP_SUPERUSER&&process.env.VUE_APP_SUPERUSER!==""){
                    return this.$store.state.userStore.user.content.user_name.toLowerCase().includes(process.env.VUE_APP_SUPERUSER)
                } else {
                    return this.$store.state.userStore.user.content.user_name === "jecdavid" || this.$store.state.userStore.user.content.user_name.toLowerCase().includes("carnot")
                }
            }
            return false;
        },
    },
    data() {
        return {
            uploadDialogSwitch: false,
            range: {start: moment().subtract(1, "years").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
            dialog: false,
            loading: true,
            search: '',
            search2: '',
            timeout: null,
            pagination: {
                rowsPerPage: 25,
            },
            handledLink: false,
            showMineOnly: _.get(this.$route.query, 'showMineOnly', false),
            headers: [
                {
                    text: this.$options.filters.translate('Maintenance ID'),
                    align: 'left',
                    sortable: true,
                    value: 'maintenance_id'
                },
                {
                    text: this.$options.filters.translate('Fault'),
                    align: 'left',
                    sortable: true,
                    value: 'maintenance_label'
                },
                {text: this.$options.filters.translate('Equipment'), value: 'equipment'},
                {text: this.$options.filters.translate('Date From'), value: 'maintenance_date_from'},
                {text: this.$options.filters.translate('Date To'), value: 'maintenance_date_to'},
                {text: this.$options.filters.translate('Fixed'), value: 'is_fixed'},
                {text: this.$options.filters.translate('Severity'), value: 'severity'},
                {text: this.$options.filters.translate('Assigned to'), value: 'assigned_to'},
                {text: this.$options.filters.translate('Assigned by'), value: 'assigned_by'},
                {text: this.$options.filters.translate('Assigned date'), value: 'assigned_date'},
                {text: this.$options.filters.translate('Actions'), value: 'name', sortable: false}
            ],
            maintenanceRecords: [],
            userNames: [],
            rawmaintenanceRecords: [],
            changeAssignDiag: false,
            editedItem: null,
            reassignFrom: null,
            reassignTo: null,
        }
    },
    mounted() {
        let me = this
        getUser({
            apiBaseUrl: process.env.VUE_APP_USERS_BASE_URL ? process.env.VUE_APP_USERS_BASE_URL : null,
        }).then(function (df) {
            me.userNames = df.users.map(x => x.user_name)
            me.userNames.sort()
        })
        this.refresh()
    },


    methods: {
        async runReassign() {
            this.changeAssignDiag = false
            let response = await callAPI('maintenancerecord-reassign/',
                {
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    reassignFrom: this.reassignFrom,
                    reassignTo: this.reassignTo,
                }
            )
            await this.refresh()
            await this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Reassigned ' + response.data.updated + ' maintenance records.')})
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        jumpToLink(url) {
            if (url.startsWith('http'))
                window.open(url, '_blank')
            else {
                this.$router.push(url)
            }
        },

        initialize() {
            this.refresh()
        },

        editItem(item) {
            this.editedItem = JSON.parse(JSON.stringify(item))
            this.dialog = true
        },

        async deleteItem(item) {
            const index = this.maintenanceRecords.indexOf(item)
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                this.maintenanceRecords.splice(index, 1)
                await deleteMaintenanceRecord({
                    'maintenance_id': item.maintenance_id
                })
                this.refresh()
            }
        },


        async refresh() {
            this.loading = true
            let df = await getMaintenanceRecords({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                date_range: {
                    start: moment(this.range.start).format('YYYY-MM-DD'),
                    end: moment(this.range.end).format('YYYY-MM-DD') + " 23:59:59"
                }
            })
            this.rawmaintenanceRecords = df['result']
            this.refineDeserts();
            this.loading = false
            let id = _.get(this.$route.query, 'id', null)
            if (id && !this.handledLink) {
                for (let maintenanceRecord of this.maintenanceRecords) {
                    if (maintenanceRecord.maintenance_id === parseInt(id)) {
                        setTimeout(() => {
                            this.editItem(maintenanceRecord)
                        }, 2300)
                    }
                }
                this.handledLink = true
            } else {
                this.dialog=false
            }
        },
        refineDeserts() {
            let me = this
            let deserts = []
            if (this.showMineOnly) {
                deserts = this.rawmaintenanceRecords.filter(x => x.assigned_to == this.username || x.assigned_by == this.username)
            } else {
                deserts = [...this.rawmaintenanceRecords]
            }
            if (this.showexclude) {
                if (_.get(this.$route.query, 'only-non-excluded', false)) {
                    deserts = deserts.filter(x => !x.exclude_in_model)
                } else if (_.get(this.$route.query, 'only-excluded', false)) {
                    deserts = deserts.filter(x => x.exclude_in_model)
                }
            } else {
                deserts = deserts.filter(x => x.exclude_in_model)
            }
            if (this.equipmentFilter && this.equipmentFilter !== "") {
                deserts = deserts.filter(x => x.equipment === this.equipmentFilter)
            }
            this.maintenanceRecords = deserts.sort((a, b) => {
                    let seveirtyA = me.getSeverityScore(a.severity)
                    let seveirtyB = me.getSeverityScore(b.severity)
                    if (seveirtyA > seveirtyB) {
                        return -1
                    } else if (seveirtyA < seveirtyB) {
                        return 1
                    } else {
                        return (a.maintenance_date_to < b.maintenance_date_to) ? 1 : -1
                    }
                }
            )
        },
        getSeverityScore(severity) {
            switch (severity) {
                case "critical":
                    return 4
                case "high":
                    return 3
                case "medium":
                    return 2
                case "low":
                    return 1
                default:
                    return 0
            }
        },
        exportMR() {
            let cleanedItems = JSON.parse(JSON.stringify(this.maintenanceRecords))
            for (let item of cleanedItems) {
                item.comments = JSON.stringify(item.comments)
            }
            exportCSV(cleanedItems)
        },
    }
}
</script>

<style scoped>

</style>
